const week = [6,0,1,2,3,4,5]

const dayState_NotVisible = 0
const dayState_Disabled = 1
const dayState_Enabled = 2
const dayState_FirstSelected = 4
const dayState_FirstSelected_Disabled = 5
const dayState_Selected_Enabled = 6
const dayState_Selected_Disabled = 7
const dayState_LastSelected = 8
const dayState_LastSelected_Disabled = 9

const findDate = (filter, dateA) => {
  let result = false
  for (let i = 0; i < filter.length; i++){
    let dateB = new Date(filter[i])
    if (+dateA===+dateB) {
      result = true
      break
    }
  }
  return result
}

export const DaysCalendar = (month, year, view, select, filter, tab) => {
  //const viewStart = view[0]
  //const viewEnd = view[1]
  const selectStart = select[0]
  const selectEnd = select[1]
  const firstDay = new Date(year, month, 1)
  const lastDay = new Date(year, month + 1, 0).getDate()
  const dayWeek = week[firstDay.getDay()]

  let result = []
  let line= []
  let weeks = 0

  for(let r = 0; r < dayWeek; r++) {
    line = line.concat({num: undefined, value: undefined, state: dayState_NotVisible})
  }

  for(let i = 1; i <= lastDay; i++) {
      //let fi = parseInt(arrayFilterValues[between + i], 0)
      let dt = new Date(year, month, i)
      let k = dayState_Disabled
      let fi = findDate(filter, dt)
      //if (dt<viewStart || dt>viewEnd){
      //  k = dayState_Disabled

      if (+dt===+selectStart){
        k = (fi)? dayState_FirstSelected: dayState_FirstSelected_Disabled
      }else if (+dt===+selectEnd){
        k = (fi)? dayState_LastSelected: dayState_LastSelected_Disabled
      }else if (dt>=selectStart && dt<=selectEnd){
        k = (fi)? dayState_Selected_Enabled: dayState_Selected_Disabled
      }else if (fi){
        k = dayState_Enabled
      }

      // always disable previous days prior to the selected start date
      if (tab === 4 && dt < selectStart) {
        k = dayState_Disabled
      }

      line = line.concat({num: i, value: dt.getTime(), state: k})

      let dw = week[dt.getDay()]
      if (dw===6 || i===lastDay){
        result[weeks] = line
        weeks++
        line=[]
      }
  }
  return result
}

export const MonthCalendar = (month, year) => {
  let m = month
  let y = year
  let result = []

  for(let i = 0; i <= 1; i++) {
    m += i
    let line = LineMonthCalendar(m, y)
    result = result.concat(line)
  };

  return result
}

export const LineMonthCalendar = (m, y) => {
  if (m===-1){
    m = 11
    y--
  }else if (m===12) {
    m = 0
    y++
  }
  let line=[[m, y]]

  return line
}



// WEBPACK FOOTER //
// ./src/shared/routes/components/calendar/functionsCalendar.js